import type { SuretyAccountId } from "@inrev/common";
import { UploadedDocuments } from "@portal/components/uploaded-documents";
import { FC } from "react";

type AgentUploadedDocumentsProps = {
	accountId: SuretyAccountId;
};

export const AgentUploadedDocuments: FC<AgentUploadedDocumentsProps> = ({ accountId }) => {
	return (
		<UploadedDocuments
			accountId={accountId}
			allowDelete={false}
			allowUpload={true}
			useCardLayout
			testId="agent-account-documents-card"
		/>
	);
};
